import styled from 'styled-components'

const Container = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  background-color: white;
`

export default Container



// WEBPACK FOOTER //
// ./src/Units/components/FullAreaContent.js